(() => {
  const init = () => {
    document.querySelectorAll('.gs-variations fieldset[data-gs-prompt]').forEach((set) => {
      const label = set.querySelector('.form__label__value');
      if (!label) return;

      const prompt = set.dataset.gsPrompt;
      const chosen = set.querySelector('input[type="radio"]:checked');

      if (!chosen) {
        label.textContent = prompt;
        set.classList.add('gs-awaiting-choice');
      }

      set.addEventListener('change', () => set.classList.remove('gs-awaiting-choice'), { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
